(() => {
  const DURATION = 320;
  const EASING = 'cubic-bezier(0.33, 1, 0.68, 1)';

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const primeThemeAccordion = (details, panel) => {
    if (!details.open) return;
    panel.style.height = `${panel.scrollHeight}px`;
    void panel.offsetHeight;
  };

  const animateDetails = (event, details, panel) => {
    event.preventDefault();

    const running = panel.getAnimations();
    const currentHeight = running.length ? panel.getBoundingClientRect().height : null;
    running.forEach((animation) => animation.cancel());

    const opening = !details.open;
    details.dataset.salutAnimating = 'true';
    if (opening) details.open = true;

    const target = panel.scrollHeight;
    const previousOverflow = panel.style.overflow;
    panel.style.overflow = 'hidden';

    const from = currentHeight === null ? (opening ? 0 : target) : currentHeight;

    const animation = panel.animate(
      [
        { height: `${from}px`, opacity: opening ? 0 : 1 },
        { height: `${opening ? target : 0}px`, opacity: opening ? 1 : 0 },
      ],
      { duration: DURATION, easing: EASING }
    );

    animation.onfinish = () => {
      panel.style.overflow = previousOverflow;
      if (!opening) details.open = false;
      delete details.dataset.salutAnimating;
    };
  };

  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest?.('summary');
      if (!summary) return;

      const details = summary.closest('details');
      const panel = summary.nextElementSibling;
      if (!details || !panel) return;
      // panourile de drawer sunt animate de tema prin translateX, nu prin inaltime
      if (panel.matches('.menu-drawer, .menu-drawer__submenu, .mobile-facets')) return;

      if (panel.classList.contains('custom-accordion__panel')) {
        primeThemeAccordion(details, panel);
        return;
      }

      if (prefersReducedMotion()) return;
      animateDetails(event, details, panel);
    },
    true
  );
})();
